import { Col, Row } from "react-bootstrap";
import ExpenditureProCard from "./procard/expenditureprocard";
import ExpenditureCheck from "./check/expenditurecheck";
import { useEffect, useState } from "react";
import ExpenditurePrimarySummary from "./summary/expenditureprimarysummary";
import ExpenditureCheckAddEdit from "./check/expenditurecheckaddedit";
import ExpenditureProCardAddEdit from "./procard/expenditureprocardaddedit";
import ExpenditureRefund from "./refund/expenditurerefund";
import ExpenditureRefundAddEdit from "./refund/expenditurerefundaddedit";
import useExpenditureWorksheetFetch from "../../../../hooks/use-expenditure-worksheet";
import useApi from "../../../../hooks/use-api";
import { useOutletContext } from "react-router-dom";
import PermissionReadOnlyBoundary from "../../../../auth/PermissionReadOnlyBoundary";

const ExpenditureWorksheet = ({ }) => {
    const {ApplicationID: applicationId, pagePermissions = {}, currentPageReadOnly = false} = useOutletContext();
    const [addEditIndex, setAddEditIndex] = useState(null);
    const [editItem, setEditItem] = useState(null);
    const [addEditMode, setAddEditMode] = useState(null);
    const expenditureWorksheetData = useExpenditureWorksheetFetch(2);

    const [states,setStates] = useState([]);
    const [expenditureTypes,setExpenditureTypes] = useState([]);
    const [checkTypes,setCheckTypes] = useState([]);
    const [lineItemCategories,setLineItemCategories] = useState([]);
    const [sttRttList,setSttRttList] = useState([]);
    const [adminList,setAdminList] = useState([]);
    const [userMasterList,setUserMasterList] = useState([]); //Used to lookup users that are no longer valid selections
    // const [checkUserList,setCheckUserList] = useState([]);
    const [checkReleasedToStatusList,setCheckReleasedToStatusList] =  useState([]);
    const [relatedChecks,setRelatedChecks] = useState([]);
    // const [refundReceivedList,setRefundReceivedList] = useState([]);
    // const [mfpAdminList,setMfpAdminList] =  useState([]);
    // const [copAdminList,setCopAdminList] =  useState([]);

    const [ewItems,setEwItems] = useState({
        procard: [],
        check: [],
        refund: []
    });
    const [expenditureTypeMap,setExpenditureTypeMap] = useState();
    const [expenditureSummaryTypeMap,setExpenditureSummaryTypeMap] = useState();
    const [expenditureCheckTypeMap,setExpenditureCheckTypeMap] = useState();
    const [isLoading,setIsLoading] = useState(true);
    const [silentRefreshing,setSilentRefreshing] = useState(false);
    const [pvaVal,setPvaVal] = useState(null);
    const canAddEntries = pagePermissions.canAdd === true;
    const canUpdateEntries = pagePermissions.canUpdate === true;
    const canDeleteEntries = pagePermissions.canDelete === true;

    const toggleAddEdit = (item, index, mode = item === null ? 'add' : 'edit') => {
        if(item === null && !canAddEntries){
            return;
        }

        const nextMode = item !== null && !canUpdateEntries ? 'view' : mode;

        setEditItem(item);
        setAddEditIndex(index);
        setAddEditMode(nextMode);
    };

    const returnFunction = () => {
        setEditItem(null);
        setAddEditIndex(null);
        setAddEditMode(null);
    };

    const {getRequest} = useApi();

    const Get = async() => {

        const [definitionData,worksheetData] = await Promise.all([
            getRequest('ExpenditureWorksheetDefinitions',{timestamp: Date.now()}),
            getRequest('ExpenditureWorksheet',{ApplicationID: applicationId,timestamp: Date.now()})
        ]);

        const [extractedDefinitionData,definitionStatus] = definitionData;
        const [extractedWorksheetData,worksheetStatus] = worksheetData;

        if(definitionStatus === 200 && worksheetStatus === 200){
            setStates(extractedDefinitionData.states);
            setExpenditureTypes(extractedDefinitionData.expendituretypes);
            setCheckTypes(extractedDefinitionData.checktypes);
            setLineItemCategories(extractedDefinitionData.lineitemcategories);
            setAdminList(extractedDefinitionData.lexingtonfrankfortadminlist);
            setSttRttList(extractedDefinitionData.sttrttlist);
            setUserMasterList(extractedDefinitionData.usermasterlist);
            // setCheckUserList(extractedDefinitionData.checkuserlist);
            setCheckReleasedToStatusList(extractedDefinitionData.checkreleasedtostatuslist);
            // setRefundReceivedList(extractedDefinitionData.refundreceivedlist);
            // setMfpAdminList(extractedDefinitionData.mfpadminlist);
            // setCopAdminList(extractedDefinitionData.copadminlist);
            
            const checksWithNumbers = extractedWorksheetData.check.filter(check => check.checknumber)
                .map(check => ({
                    id: check.id,
                    detail: `Check # (${check.checknumber})`
                }));

            setRelatedChecks(checksWithNumbers);

            setEwItems({
                procard: extractedWorksheetData.procard,
                check: extractedWorksheetData.check,
                refund: extractedWorksheetData.refund
            });

            const expenditureMap = extractedDefinitionData.expendituretypes.reduce((map,obj) => {
                map[obj.id] = obj.name;
                return map;
            },{});

            const expenditureSummaryMap = extractedDefinitionData.expendituretypes.reduce((map,obj) => {
                map[obj.id] = {name: obj.name, maxlimitrate: obj.maxlimitrate, pvalimitrate: obj.pvalimitrate};
                return map;
            },{});

            const expenditureCheckTypeMap = extractedDefinitionData.checktypes.reduce((map,obj) => {
                map[obj.id] = obj.name;
                return map;
            },{});

            setExpenditureTypeMap(expenditureMap);
            setExpenditureSummaryTypeMap(expenditureSummaryMap)
            setExpenditureCheckTypeMap(expenditureCheckTypeMap);
            setPvaVal(extractedWorksheetData.pvavalue);

            setIsLoading(false);
        }
    }

    const silentRefresh = async() => {
        setSilentRefreshing(true);
        const [data,status] = await getRequest('ExpenditureWorksheet',{ApplicationID: applicationId,timestamp: Date.now()});

        if(status === 200){
            setEwItems({
                procard: data.procard,
                check: data.check,
                refund: data.refund
            });

            const checksWithNumbers = data.check.filter(check => check.checknumber)
                .map(check => ({
                    id: check.id,
                    detail: `Check # (${check.checknumber})`
                }));

            setRelatedChecks(checksWithNumbers);
        }

        setSilentRefreshing(false);
    }

    useEffect(() => {
        Get();
    },[])

    const addEditReadOnly = currentPageReadOnly
        || addEditMode === 'view'
        || (editItem !== null && !canUpdateEntries)
        || (editItem === null && addEditIndex !== null && !canAddEntries);

    const renderReadOnlyAddEdit = (children) => (
        <PermissionReadOnlyBoundary readOnly={addEditReadOnly}>
            {children}
        </PermissionReadOnlyBoundary>
    );

    const RenderAddEditIndex = (index) => {



        switch (index) {
            case 1:
                return (
                    <Col xs={12}>
                        {renderReadOnlyAddEdit(
                            <ExpenditureProCardAddEdit
                                returnFunction={returnFunction}
                                expenditureTypes={expenditureTypes}
                                states={states}
                                lineItemCategories={lineItemCategories}
                                ApplicationID={applicationId}
                                procardId={editItem}
                                refresh={silentRefresh}
                                readOnly={addEditReadOnly}
                            />
                        )}
                    </Col>
                )
            case 2:
                return (
                    <Col xs={12}>
                        {renderReadOnlyAddEdit(
                            <ExpenditureCheckAddEdit
                                returnFunction={returnFunction}
                                states={states}
                                expenditureTypes={expenditureTypes}
                                checkTypes={checkTypes}
                                lineItemCategories={lineItemCategories}
                                // users={checkUserList}
                                sttRttlist={sttRttList}
                                userMasterList={userMasterList}
                                statusList={checkReleasedToStatusList}
                                ApplicationID={applicationId}
                                checkId={editItem}
                                refresh={silentRefresh}
                                readOnly={addEditReadOnly}
                            />
                        )}
                    </Col>
                )
            case 3:
                return (
                    <Col xs={12}>
                        {renderReadOnlyAddEdit(
                            <ExpenditureRefundAddEdit
                                RefundID={editItem}
                                ApplicationID={applicationId}
                                returnFunction={returnFunction}
                                refresh={silentRefresh}
                                checkTypes={checkTypes}
                                lineItemCategories={lineItemCategories}
                                relatedChecks={relatedChecks}
                                states={states}
                                lexFrankfortAdmins={adminList}
                                userMasterList={userMasterList}
                                readOnly={addEditReadOnly}
                            />
                        )}
                    </Col>
                )
            default:
                return (
                    <>
                        <Col xs={12} className="mb-2">
                            <ExpenditurePrimarySummary
                                proCardAmounts={expenditureWorksheetData.amounts.proCard}
                                checkAmounts={expenditureWorksheetData.amounts.checks}
                                refundAmounts={expenditureWorksheetData.amounts.refunds}
                                items={ewItems}
                                expenditureTypeMap={expenditureSummaryTypeMap}
                                pvavalue={pvaVal}
                            />
                        </Col>
                        <Col xs={12} md={4} className="mb-2">
                            <ExpenditureProCard
                                toggleAddEditMode={toggleAddEdit}
                                addEditIndex={1}
                                proCards={ewItems.procard}
                                expenditureTypemap={expenditureTypeMap}
                                ApplicationID={applicationId}
                                refreshFunction={silentRefresh}
                                canAdd={canAddEntries}
                                canUpdate={canUpdateEntries}
                                canDelete={canDeleteEntries}
                            />
                        </Col>
                        <Col xs={12} md={4} className="mb-2">
                            <ExpenditureCheck
                                toggleAddEditMode={toggleAddEdit}
                                addEditIndex={2}
                                checks={ewItems.check}
                                expenditureTypemap={expenditureTypeMap}
                                ApplicationID={applicationId}
                                refreshFunction={silentRefresh}
                                canAdd={canAddEntries}
                                canUpdate={canUpdateEntries}
                                canDelete={canDeleteEntries}
                            />
                        </Col>
                        <Col xs={12} md={4} className="mb-2">
                            <ExpenditureRefund
                                toggleAddEditMode={toggleAddEdit}
                                addEditIndex={3}
                                refunds={ewItems.refund}
                                checkTypeMap={expenditureCheckTypeMap}
                                refresh={silentRefresh}
                                ApplicationID={applicationId}
                                canAdd={canAddEntries}
                                canUpdate={canUpdateEntries}
                                canDelete={canDeleteEntries}
                            />
                        </Col>
                    </>
                )
        }
    }

    if(isLoading){
        return(
            <div>loading...</div>
        )
    }

    return (
        <Row>
            {
                RenderAddEditIndex(addEditIndex)
            }
        </Row>
    )

}

export default ExpenditureWorksheet;
